import React, { useState } from 'react';
import './Settings.css';
import CloseIcon from '@mui/icons-material/Close';

function Settings({ onClose }) {
    const [settings, setSettings] = useState({
        darkMode: false,
        notifications: true,
        emailNotifications: true,
        autoSave: true,
        language: 'english',
        theme: 'blue',
        fontSize: 'medium'
    });

    const handleToggle = (setting) => {
        setSettings(prev => ({
            ...prev,
            [setting]: !prev[setting]
        }));
    };

    const handleSelectChange = (setting, value) => {
        setSettings(prev => ({
            ...prev,
            [setting]: value
        }));
    };

    const handleThemeSelect = (theme) => {
        setSettings(prev => ({
            ...prev,
            theme
        }));
    };

    const handleSave = () => {
        // Здесь можно сохранить настройки в localStorage или отправить на сервер
        localStorage.setItem('appSettings', JSON.stringify(settings));
        console.log('Settings saved:', settings);
        alert('Настройки сохранены! (В разработке)');
        onClose();
    };

    const handleReset = () => {
        setSettings({
            darkMode: false,
            notifications: true,
            emailNotifications: true,
            autoSave: true,
            language: 'english',
            theme: 'blue',
            fontSize: 'medium'
        });
    };

    return (
        <div className="settings-container" onClick={onClose}>
            <div className="settings-modal" onClick={e => e.stopPropagation()}>
                <div className="settings-header">
                    <h2>Настройки</h2>
                    <button className="close-button" onClick={onClose}>
                        <CloseIcon />
                    </button>
                </div>

                <div className="settings-content">
                    {/* Баннер с предупреждением о разработке */}
                    <div className="dev-banner">
                        <strong>⚠️ Настройки в разработке</strong>
                        Эти настройки находятся в активной разработке и могут работать нестабильно. Не рекомендуется применять их в рабочей среде.
                    </div>

                    <div className="settings-section">
                        <h3>Внешний вид</h3>

                        <div className="setting-item">
                            <div className="setting-info">
                                <span className="setting-title">Темный режим</span>
                                <span className="setting-description">Переключиться на темную тему</span>
                            </div>
                            <label className="toggle-switch">
                                <input
                                    type="checkbox"
                                    checked={settings.darkMode}
                                    onChange={() => handleToggle('darkMode')}
                                />
                                <span className="toggle-slider"></span>
                            </label>
                        </div>

                        <div className="setting-item">
                            <div className="setting-info">
                                <span className="setting-title">Цветовая тема</span>
                                <span className="setting-description">Выберите предпочитаемый цвет темы</span>
                            </div>
                            <div className="theme-options">
                                <div
                                    className={`theme-option theme-blue ${settings.theme === 'blue' ? 'active' : ''}`}
                                    onClick={() => handleThemeSelect('blue')}
                                    title="Синяя тема"
                                />
                                <div
                                    className={`theme-option theme-green ${settings.theme === 'green' ? 'active' : ''}`}
                                    onClick={() => handleThemeSelect('green')}
                                    title="Зеленая тема"
                                />
                                <div
                                    className={`theme-option theme-purple ${settings.theme === 'purple' ? 'active' : ''}`}
                                    onClick={() => handleThemeSelect('purple')}
                                    title="Фиолетовая тема"
                                />
                                <div
                                    className={`theme-option theme-dark ${settings.theme === 'dark' ? 'active' : ''}`}
                                    onClick={() => handleThemeSelect('dark')}
                                    title="Темная тема"
                                />
                            </div>
                        </div>

                        <div className="setting-item">
                            <div className="setting-info">
                                <span className="setting-title">Размер шрифта</span>
                                <span className="setting-description">Настройте размер текста</span>
                            </div>
                            <div className="select-wrapper">
                                <select
                                    value={settings.fontSize}
                                    onChange={(e) => handleSelectChange('fontSize', e.target.value)}
                                >
                                    <option value="small">Маленький</option>
                                    <option value="medium">Средний</option>
                                    <option value="large">Большой</option>
                                    <option value="xlarge">Очень большой</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="settings-section">
                        <h3>Уведомления</h3>

                        <div className="setting-item">
                            <div className="setting-info">
                                <span className="setting-title">Push-уведомления</span>
                                <span className="setting-description">Получать уведомления в браузере</span>
                            </div>
                            <label className="toggle-switch">
                                <input
                                    type="checkbox"
                                    checked={settings.notifications}
                                    onChange={() => handleToggle('notifications')}
                                />
                                <span className="toggle-slider"></span>
                            </label>
                        </div>

                        <div className="setting-item">
                            <div className="setting-info">
                                <span className="setting-title">Email-уведомления</span>
                                <span className="setting-description">Получать обновления по электронной почте</span>
                            </div>
                            <label className="toggle-switch">
                                <input
                                    type="checkbox"
                                    checked={settings.emailNotifications}
                                    onChange={() => handleToggle('emailNotifications')}
                                />
                                <span className="toggle-slider"></span>
                            </label>
                        </div>
                    </div>

                    <div className="settings-section">
                        <h3>Общие</h3>

                        <div className="setting-item">
                            <div className="setting-info">
                                <span className="setting-title">Автосохранение</span>
                                <span className="setting-description">Автоматически сохранять вашу работу</span>
                            </div>
                            <label className="toggle-switch">
                                <input
                                    type="checkbox"
                                    checked={settings.autoSave}
                                    onChange={() => handleToggle('autoSave')}
                                />
                                <span className="toggle-slider"></span>
                            </label>
                        </div>

                        <div className="setting-item">
                            <div className="setting-info">
                                <span className="setting-title">Язык</span>
                                <span className="setting-description">Язык интерфейса</span>
                            </div>
                            <div className="select-wrapper">
                                <select
                                    value={settings.language}
                                    onChange={(e) => handleSelectChange('language', e.target.value)}
                                >
                                    <option value="english">Английский</option>
                                    <option value="spanish">Испанский</option>
                                    <option value="french">Французский</option>
                                    <option value="german">Немецкий</option>
                                    <option value="russian">Русский</option>
                                    <option value="chinese">Китайский</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="button-row">
                        <button className="secondary-button" onClick={handleReset}>
                            Сбросить по умолчанию
                        </button>
                        <button className="primary-button" onClick={handleSave}>
                            Сохранить изменения
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Settings;